import { useProgrammatic } from '@oruga-ui/oruga-next';
import NotificationMessage from '@/components/NotificationMessage.vue';

const {oruga} = useProgrammatic();

export default function NotificationError(config: any = {}, error: any = null) {
  if (error && error.errors) {
    config.message = error.errors.map((e: any) => e.detail || e.message).join(' ');

    openNotification(config);
  }
  else if (config.message) {

    openNotification(config);
  } else {
    console.error('Cannot find error message.');
  }
};

function openNotification(config: any) {
  const {message, ...options} = config;

  oruga.notification.open({
    position: 'top-right',
    variant: 'danger',
    duration: 5000,
    component: NotificationMessage,
    props: {
      message,
    },
    ...options,
  });
}
